import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import H, { cardBasePropKeys as I } from "../../card/src/Card.js";
import { NDialog as V } from "../../dialog/src/Dialog.js";
import { dialogPropKeys as W } from "../../dialog/src/dialogProps.js";
import { drawerBodyInjectionKey as X } from "../../drawer/src/interface.js";
import { popoverBodyInjectionKey as Y } from "../../popover/src/interface.js";
import { useDragModal as _ } from "./composables.js";
import { modalInjectionKey as z, modalBodyInjectionKey as G } from "./interface.js";
import { presetProps as J } from "./presetProps.js";
import { normalizeClass as B } from "../../../../../../@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import { useLockHtmlScroll as Q } from "../../_utils/composable/use-lock-html-scroll.js";
import { getFirstSlotVNodeWithTypedProps as U } from "../../_utils/vue/get-first-slot-vnode.js";
import { warn as Z } from "../../_utils/naive/warn.js";
import ee from "../../_internal/scrollbar/src/Scrollbar.js";
import { FocusTrap as te } from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/focus-trap/src/index.js";
import re from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/clickoutside.js";
import { keep as F } from "../../_utils/vue/keep.js";
import { defineComponent as oe, inject as ie, watch as y, computed as C, nextTick as w, provide as b, cloneVNode as se, mergeProps as le, withDirectives as $, h as u } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as c, toRef as O } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { vShow as E, Transition as ne } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
const $e = oe({
  name: "ModalBody",
  inheritAttrs: !1,
  slots: Object,
  props: Object.assign(Object.assign({
    show: {
      type: Boolean,
      required: !0
    },
    preset: String,
    displayDirective: {
      type: String,
      required: !0
    },
    trapFocus: {
      type: Boolean,
      default: !0
    },
    autoFocus: {
      type: Boolean,
      default: !0
    },
    blockScroll: Boolean,
    draggable: {
      type: [Boolean, Object],
      default: !1
    }
  }, J), {
    renderMask: Function,
    // events
    onClickoutside: Function,
    onBeforeLeave: {
      type: Function,
      required: !0
    },
    onAfterLeave: {
      type: Function,
      required: !0
    },
    onPositiveClick: {
      type: Function,
      required: !0
    },
    onNegativeClick: {
      type: Function,
      required: !0
    },
    onClose: {
      type: Function,
      required: !0
    },
    onAfterEnter: Function,
    onEsc: Function
  }),
  setup(t) {
    const n = c(null), l = c(null), a = c(t.show), f = c(null), m = c(null), i = ie(z);
    let o = null;
    y(O(t, "show"), (e) => {
      e && (o = i.getMousePosition());
    }, {
      immediate: !0
    });
    const {
      stopDrag: s,
      startDrag: h,
      draggableRef: p,
      draggableClassRef: d
    } = _(O(t, "draggable"), {
      onEnd: (e) => {
        R(e);
      }
    }), g = C(() => B([t.titleClass, d.value])), N = C(() => B([t.headerClass, d.value]));
    y(O(t, "show"), (e) => {
      e && (a.value = !0);
    }), Q(C(() => t.blockScroll && a.value));
    function T() {
      if (i.transformOriginRef.value === "center")
        return "";
      const {
        value: e
      } = f, {
        value: r
      } = m;
      if (e === null || r === null)
        return "";
      if (l.value) {
        const v = l.value.containerScrollTop;
        return `${e}px ${r + v}px`;
      }
      return "";
    }
    function R(e) {
      if (i.transformOriginRef.value === "center" || !o || !l.value)
        return;
      const r = l.value.containerScrollTop, {
        offsetLeft: v,
        offsetTop: x
      } = e, q = o.y, K = o.x;
      f.value = -(v - K), m.value = -(x - q - r), e.style.transformOrigin = T();
    }
    function P(e) {
      w(() => {
        R(e);
      });
    }
    function A(e) {
      e.style.transformOrigin = T(), t.onBeforeLeave();
    }
    function L(e) {
      const r = e;
      p.value && h(r), t.onAfterEnter && t.onAfterEnter(r);
    }
    function S() {
      a.value = !1, f.value = null, m.value = null, s(), t.onAfterLeave();
    }
    function j() {
      const {
        onClose: e
      } = t;
      e && e();
    }
    function D() {
      t.onNegativeClick();
    }
    function M() {
      t.onPositiveClick();
    }
    const k = c(null);
    return y(k, (e) => {
      e && w(() => {
        const r = e.el;
        r && n.value !== r && (n.value = r);
      });
    }), b(G, n), b(X, null), b(Y, null), {
      mergedTheme: i.mergedThemeRef,
      appear: i.appearRef,
      isMounted: i.isMountedRef,
      mergedClsPrefix: i.mergedClsPrefixRef,
      bodyRef: n,
      scrollbarRef: l,
      draggableClass: d,
      displayed: a,
      childNodeRef: k,
      cardHeaderClass: N,
      dialogTitleClass: g,
      handlePositiveClick: M,
      handleNegativeClick: D,
      handleCloseClick: j,
      handleAfterEnter: L,
      handleAfterLeave: S,
      handleBeforeLeave: A,
      handleEnter: P
    };
  },
  render() {
    const {
      $slots: t,
      $attrs: n,
      handleEnter: l,
      handleAfterEnter: a,
      handleAfterLeave: f,
      handleBeforeLeave: m,
      preset: i,
      mergedClsPrefix: o
    } = this;
    let s = null;
    if (!i) {
      if (s = U("default", t.default, {
        draggableClass: this.draggableClass
      }), !s) {
        Z("modal", "default slot is empty");
        return;
      }
      s = se(s), s.props = le({
        class: `${o}-modal`
      }, n, s.props || {});
    }
    return this.displayDirective === "show" || this.displayed || this.show ? $(u("div", {
      role: "none",
      class: `${o}-modal-body-wrapper`
    }, u(ee, {
      ref: "scrollbarRef",
      theme: this.mergedTheme.peers.Scrollbar,
      themeOverrides: this.mergedTheme.peerOverrides.Scrollbar,
      contentClass: `${o}-modal-scroll-content`
    }, {
      default: () => {
        var h;
        return [(h = this.renderMask) === null || h === void 0 ? void 0 : h.call(this), u(te, {
          disabled: !this.trapFocus,
          active: this.show,
          onEsc: this.onEsc,
          autoFocus: this.autoFocus
        }, {
          default: () => {
            var p;
            return u(ne, {
              name: "fade-in-scale-up-transition",
              appear: (p = this.appear) !== null && p !== void 0 ? p : this.isMounted,
              onEnter: l,
              onAfterEnter: a,
              onAfterLeave: f,
              onBeforeLeave: m
            }, {
              default: () => {
                const d = [[E, this.show]], {
                  onClickoutside: g
                } = this;
                return g && d.push([re, this.onClickoutside, void 0, {
                  capture: !0
                }]), $(this.preset === "confirm" || this.preset === "dialog" ? u(V, Object.assign({}, this.$attrs, {
                  class: [`${o}-modal`, this.$attrs.class],
                  ref: "bodyRef",
                  theme: this.mergedTheme.peers.Dialog,
                  themeOverrides: this.mergedTheme.peerOverrides.Dialog
                }, F(this.$props, W), {
                  titleClass: this.dialogTitleClass,
                  "aria-modal": "true"
                }), t) : this.preset === "card" ? u(H, Object.assign({}, this.$attrs, {
                  ref: "bodyRef",
                  class: [`${o}-modal`, this.$attrs.class],
                  theme: this.mergedTheme.peers.Card,
                  themeOverrides: this.mergedTheme.peerOverrides.Card
                }, F(this.$props, I), {
                  headerClass: this.cardHeaderClass,
                  "aria-modal": "true",
                  role: "dialog"
                }), t) : this.childNodeRef = s, d);
              }
            });
          }
        })];
      }
    })), [[E, this.displayDirective === "if" || this.displayed || this.show]]) : null;
  }
});
export {
  $e as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/modal/src/BodyWrapper.js
// module id = 1719
// module chunks = 67